<template>
  <div class="columns">
    <b-autocomplete
        class="column is-4 pt-0 is-narrow"
        rounded
        v-model="searchInput"
        :data="filteredDataArray"
        placeholder="Search keyword"
        icon-right="magnify"
        clearable
        @typing="filterAnnouncement('typing')"
        @select="filterAnnouncement('select')">
        <template #empty>No results found</template>
    </b-autocomplete>
    <div class="column pt-0"></div>
  </div>
</template>

<script>
import debounce from 'lodash/debounce';

export default {
  props: ['contentList', 'dropdownList'],
  data() {
    return {
      searchInput: ''
    }
  },
  methods: {
    filterAnnouncement: debounce(function (type) {
      let filteredList = [];
      if(this.searchInput === ''){
        filteredList = this.contentList;
      }
      else if(type === 'select'){
        filteredList = this.contentList.filter(i => i.attributes.title === this.searchInput);
      }else if(type === 'typing'){
        filteredList = this.contentList.filter((option) => {
          return option.attributes.title
            .toString()
            .toLowerCase()
            .indexOf(this.searchInput.toLowerCase()) >= 0
        })
      }
      this.$emit('set-content-array', filteredList);
    }, 500)  
  },
  computed: {
    filteredDataArray() {
      return this.dropdownList.filter((option) => {
        return option
          .toString()
          .toLowerCase()
          .indexOf(this.searchInput.toLowerCase()) >= 0
      })
    }
  }
}
</script>

<style scoped lang="scss">

:deep(){
  .dropdown-content {
    background-color: white;
    text-align: left;
  }

  .control.has-icons-right .icon.is-right {
    padding-right: 20px;
  }

  .control {
    display: block;
    position: relative;
    .input, .textarea, .select, select {
      color: #363636 !important;
      background: #FFFFFF !important;
    }

    .input::placeholder {
      color: #363636 !important;
    }
  }
  
  @media screen and (max-width: 1023px){
    .control.has-icons-right .icon.is-right{
      // height: -webkit-fill-available;
      padding-right: 20px;
    }
    
    .control.has-icons-left .input, .icon.is-left {
      border-radius: 0 !important;
      font-weight: normal;
      font-size: inherit;
      color: #dbdbdb !important;
      padding-right: 20px !important;
    }
  }

  @media screen and (max-width: 768px){
    .control {
      padding-left: 0;
      padding-right: 0;
    }
  }
}

</style>
